module.exports = __webpack_public_path__ + "static/media/promotion_carousel_page.bcb5c8f0.png";